import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import type { NavigateOptions } from 'react-router-dom'
import { useAppStore } from '@/store/appStore'

/**
 * `useNavigate` that stops to ask when there is unsaved note text.
 *
 * Every in-app route change that can take the user away from the practice or practice area whose
 * note is open goes through this. React Router can only block navigation through a data router,
 * and this app mounts a plain <BrowserRouter>, so the check has to live at the call sites. Browser
 * back/forward and tab close are covered separately by useNavigationWarning.
 */
export function useGuardedNavigate() {
  const navigate = useNavigate()
  const requestGuardedAction = useAppStore((s) => s.requestGuardedAction)

  return useCallback(
    (to: string, options?: NavigateOptions) => {
      requestGuardedAction(() => navigate(to, options))
    },
    [navigate, requestGuardedAction]
  )
}
